<template>
  <div class="dashboard-container">
    <div class="test_box" :class="{'test_box1':ShowTest}" v-if="btn_test">
      <el-button size="mini" type="primary" @click="ShowTest=!ShowTest">测 试</el-button>
      <div style="margin-top: 10px;" v-if="ShowTest">
        <el-date-picker
          size="mini"
          v-model="TestTime"
          type="datetime"
          value-format="yyyy-MM-dd HH:mm:ss"
        />
        <el-button size="mini" type="primary" style="margin-left: 10px;" @click="getData">设置时间</el-button>
      </div>
    </div>
    <el-row :gutter="10">
      <el-col :span="24">
        <el-tabs v-model="active" @tab-click="handleClick" type="card" class="cardTabs indexTabs">
          <el-tab-pane :label="$commonJs.getToday()+' 课堂考勤'" name="0" v-if="$permission.can('学生考勤','m_workbench')">
            <div class="el-col-box">
              <grades ref="grades" />
            </div>
            <div class="el-col-box">
              <nowleave ref="nowleave" />
            </div>
          </el-tab-pane>
          <!-- <el-tab-pane label="晚休考勤" name="1" v-if="$permission.canRead('/attendance/night')">
            <night ref="night" id="night" isIndex />
          </el-tab-pane>
          <el-tab-pane label="留宿自习考勤" name="2" v-if="$permission.canRead('/attendance/selfstudyat')">
            <selfstudyat ref="selfstudyat" id="selfstudyat" isIndex />
          </el-tab-pane> -->
        </el-tabs>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import scanTimes from "@/components/dashboard/date/scanTimes";
import grades from "@/components/dashboard/cards/student/list";
import nowleave from "@/components/dashboard/cards/nowleave/list";
import night from '@/components/attendance/night/list'
import selfstudyat from '@/components/attendance/selfstudyat/list'

export default {
  name: "home",
  components: {
    scanTimes,
    grades,
    nowleave,
    night,
    selfstudyat
  },
  data() {
    return {
      isMB: this.$store.state.isMB,
      api: require("@/api/at/attendance").default,
      data: {
        AddCount: 0, //新增
        EditCount: 0, //编辑
      },
      active: "0",
      ShowTest: false,
      TestTime: null,
      btn_test: false,
    };
  },
  mounted() {
    console.log("query", this.$route.query);
    if (this.$route.query && this.$route.query.test == "1") {
      this.btn_test = true;
    } else {
      localStorage.removeItem("index-test-time");
      this.btn_test = false;
    }
    this.getData();
    let self = this;
    setInterval(function () {
      self.getData();
    }, 300000);
    //-----------------------
    if(!this.$permission.can('学生考勤','m_workbench')) {
      if(this.$permission.canRead("/attendance/night")) {
        this.active = "1";
        this.handleClick();
      } else if(this.$permission.canRead("/attendance/selfstudyat")) {
        this.active = "2";
        this.handleClick();
      }
    }
    // this.$router.push("/po/hwreview");
  },
  methods: {
    getData() {
      localStorage.setItem("index-test-time", this.TestTime);
      var time = this.TestTime ? this.TestTime : new Date();
      this.api.getIndexStat(time).then((res) => {
        // console.log("getIndexStat", res);
        if (res.Data) {
          // if (this.$refs.teacher) this.$refs.teacher.setData(res.Data);
          if (res.Data.Grades) {
            if (this.$refs.grades) this.$refs.grades.setData(res.Data.Grades);
          }
          // if (this.$refs.leave) this.$refs.leave.setData(res.Data);
          if (this.$refs.nowleave) this.$refs.nowleave.setData(res.Data, time);
        }
      });
    },
    handleClick() {
      this.$nextTick(() => {
        if(this.active=="1") this.$refs.night.getNightSt();
        else if(this.active=="2") this.$refs.selfstudyat.getData();
      })
    },
  },
};
</script>
<style  lang="scss" scoped>
.dashboard-container {
  padding: 20px;
  background-color: rgb(240, 242, 245);
  position: relative;
  height: calc(100vh - 84px);
  overflow: auto;
  background: url("../assets/bg.png") center bottom no-repeat;
  @media (max-width: 1000px) {
    height: 100%;
    margin-top: -10px;
  }
  @media screen and (max-width: 767px) {
      padding: 10px 5px !important;
  }
  background-size: 100% 100%;
}

.test_box {
  position: absolute;
  z-index: 999;
  padding: 5px;
  top: 0;
}

.test_box1 {
  width: 339px;
  background-color: #ffffff;
  border: 1px solid #959595;
}

.el-col-box {
  padding: 15px;
  position: relative;
  width: 100%;
  border-radius: 4px;
  border: 1px solid #ebeef5;
  background-color: #ffffff;
  color: #8c1515;
  -webkit-transition: 0.3s;
  transition: 0.3s;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  // height: 350px;
  margin-bottom: 10px;
  .title {
    font-size: 72px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -100%);
    @media (max-width: 767px) {
      font-size: 32px;
      letter-spacing: 2px;
      white-space: nowrap;
    }
  }
  .el-row {
    margin: 0px;
  }

  .box-left {
    width: 120px;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
  }
  .box-right {
    width: calc(100% - 120px);
    position: absolute;
    top: 50%;
    right: 0;
    transform: translateY(-50%);
    .count-title {
      font-size: 28px;
      font-weight: bold;
      color: #808080;
      text-align: right;
    }
    .count {
      font-size: 48px;
      text-align: right;
    }
  }

  .footer {
    font-size: 30px;
    position: absolute;
    width: calc(100% - 30px);
    bottom: 18px;
    text-align: right;
    border-top: 1px solid #dcdfe6;
    span {
      cursor: pointer;
    }
  }
}
.el-col {
  padding: 0 8px !important;
}
.showDate {
  color: #8c1515;
  font-weight: bold;
  font-size: 16px;
  margin: -10px 0 8px;
  display: block;
}
.indexTabs {
  /deep/ .el-tabs__header {
    margin-bottom: 0 !important;
  }
  /deep/ .el-tabs__item {
      color: #606266;
    &:hover {
      color: #8c1515;
    }
  }
  /deep/ .el-tabs__item.is-active {
    color: #8c1515;
    background-color: #fff;
  }
  //----------------------------
  #night {
    background-color:#fff;
    padding-top: 15px;
    border: 1px solid #ddd;
    margin-bottom: 25px;
    /deep/ .checkinge-query {
      padding-left: 15px;
      @media screen and (max-width: 767px) {
        padding-left: 9px;
      }
    }
    /deep/ .border {
      height: calc(100vh - 265px) !important;
      border: none;
      margin-bottom: 0;
      padding-top: 0;
      @media screen and (max-width: 767px) {
        height: calc(100vh - 315px) !important;
      }
      .table {
        padding-bottom: 0;
      }
    }
    /deep/ .footer {
      margin: 8px 0 0;
    }
  }
  //----------------------------
  #selfstudyat {
    margin-bottom: 25px;
    /deep/ .checkinge-query {
      background-color: #fff;
      padding: 15px 0 5px 15px;
      border: 1px solid #ddd;
      border-bottom: none;
      @media screen and (max-width: 767px) {
        padding-left: 9px;
      }
    }
    /deep/ .border {
      margin-top: 0;
      border-top: none;
      background-color:#fff;
      height: calc(100vh - 250px);
      @media screen and (max-width: 767px) {
        height: calc(100vh - 325px);
        margin-bottom: 10px;
      }
      .table-high span {
        @media screen and (max-width: 767px) {
          text-indent: 5px;
        }
      }
      .el-collapse-item__header.is-active,.el-collapse-item__arrow {
        background-color: #fff;
      }
      .table-high {
        min-width: 51px;
      }
    }
    /deep/ .tb-box {
      background: #fff;
      padding: 12px;
      border-radius: 4px;
      margin-top: 10px;
      @media screen and (max-width: 767px) {
        padding: 8px;
      }
      .el-table {
        margin-top: 0 !important;
      }
    }
  }
}
</style>